var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { action, observable, runInAction, makeObservable } from "mobx";
import DeveloperError from "terriajs-cesium/Source/Core/DeveloperError";
import isDefined from "../../Core/isDefined";
import loadJson from "../../Core/loadJson";

/*
Encapsulates one entry in regionMapping.json
Responsibilities:
- communicate with MVT server
- provide region IDs for a given region type
- determine whether a given column name matches
- identify region and disambiguation columns
- provide a lookup function for a given column of data
*/
let RegionProvider = (_class = class RegionProvider {
  get regions() {
    return this._regions;
  }

  /**
   * Look-up table of attributes, for speed.
   */

  get loaded() {
    return this._loaded;
  }
  constructor(regionType, properties, corsProxy) {
    var _properties$serverMin, _properties$serverMax, _properties$serverMax2, _properties$aliases, _properties$uniqueIdP, _properties$textCodes;
    _defineProperty(this, "corsProxy", void 0);
    _defineProperty(this, "regionType", void 0);
    _defineProperty(this, "regionProp", void 0);
    _defineProperty(this, "nameProp", void 0);
    _defineProperty(this, "description", void 0);
    _defineProperty(this, "layerName", void 0);
    _defineProperty(this, "server", void 0);
    _defineProperty(this, "serverSubdomains", void 0);
    _defineProperty(this, "serverMinZoom", void 0);
    _defineProperty(this, "serverMaxZoom", void 0);
    _defineProperty(this, "serverMaxNativeZoom", void 0);
    _defineProperty(this, "bbox", void 0);
    _defineProperty(this, "aliases", void 0);
    _defineProperty(this, "serverReplacements", void 0);
    _defineProperty(this, "dataReplacements", void 0);
    _defineProperty(this, "disambigProp", void 0);
    _defineProperty(this, "uniqueIdProp", void 0);
    _defineProperty(this, "textCodes", void 0);
    _defineProperty(this, "regionIdsFile", void 0);
    _defineProperty(this, "regionDisambigIdsFile", void 0);
    _defineProperty(this, "disambigDataReplacements", void 0);
    _defineProperty(this, "disambigServerReplacements", void 0);
    _defineProperty(this, "disambigAliases", void 0);
    _defineProperty(this, "_appliedReplacements", {
      serverReplacements: {},
      disambigServerReplacements: {},
      dataReplacements: {},
      disambigDataReplacements: {}
    });
    /**
     * Array of attributes of each region, once retrieved from the server.
     */
    _defineProperty(this, "_regions", []);
    _defineProperty(this, "_idIndex", {});
    /** Cache the loadRegionID promises so they are not regenerated each time until this._regions is defined. */
    _defineProperty(this, "_loadRegionIDsPromises", undefined);
    /** Flag to indicate if loadRegionID has finished */
    _initializerDefineProperty(this, "_loaded", _descriptor, this);
    makeObservable(this);
    this.regionType = regionType;
    this.corsProxy = corsProxy;
    this.regionProp = properties.regionProp;
    this.nameProp = properties.nameProp;
    this.description = properties.description;
    this.layerName = properties.layerName;
    this.server = properties.server;
    this.serverSubdomains = properties.serverSubdomains;
    this.serverMinZoom = (_properties$serverMin = properties.serverMinZoom) !== null && _properties$serverMin !== void 0 ? _properties$serverMin : 0;
    this.serverMaxZoom = (_properties$serverMax = properties.serverMaxZoom) !== null && _properties$serverMax !== void 0 ? _properties$serverMax : Infinity;
    this.serverMaxNativeZoom = (_properties$serverMax2 = properties.serverMaxNativeZoom) !== null && _properties$serverMax2 !== void 0 ? _properties$serverMax2 : this.serverMaxZoom;
    this.bbox = properties.bbox;
    this.aliases = (_properties$aliases = properties.aliases) !== null && _properties$aliases !== void 0 ? _properties$aliases : [this.regionType];
    this.serverReplacements = properties.serverReplacements instanceof Array ? properties.serverReplacements.map(function (r) {
      return [r[0], r[1].toLowerCase(), new RegExp(r[0].toLowerCase(), "gi")];
    }) : [];
    this.dataReplacements = properties.dataReplacements instanceof Array ? properties.dataReplacements.map(function (r) {
      return [r[0], r[1].toLowerCase(), new RegExp(r[0].toLowerCase(), "gi")];
    }) : [];
    this.disambigProp = properties.disambigProp;
    this.uniqueIdProp = (_properties$uniqueIdP = properties.uniqueIdProp) !== null && _properties$uniqueIdP !== void 0 ? _properties$uniqueIdP : "FID";
    this.textCodes = (_properties$textCodes = properties.textCodes) !== null && _properties$textCodes !== void 0 ? _properties$textCodes : false; // yes, it's singular...

    this.regionIdsFile = properties.regionIdsFile;
    this.regionDisambigIdsFile = properties.regionDisambigIdsFile;
  }
  setDisambigProperties(dp) {
    this.disambigDataReplacements = dp === null || dp === void 0 ? void 0 : dp.dataReplacements;
    this.disambigServerReplacements = dp === null || dp === void 0 ? void 0 : dp.serverReplacements;
    this.disambigAliases = dp === null || dp === void 0 ? void 0 : dp.aliases;
  }

  /**
   * Given an entry from the region mapping config, load the IDs that correspond to it, and possibly the disambiguation properties.
   */
  async loadRegionIDs() {
    try {
      if (this._regions.length > 0) {
        return; // already loaded, so return insta-promise.
      }
      if (this.server === undefined) {
        // technically this may not be a problem yet, but it will be when we want to actually fetch tiles.
        throw new DeveloperError("No server for region mapping defined: " + this.regionType);
      }
      // Check for a pre-calculated promise (which may not have resolved yet), and returned that if it exists.
      if (!isDefined(this._loadRegionIDsPromises)) {
        const fetchAndProcess = async (idListFile, disambig) => {
          if (!isDefined(idListFile)) {
            return;
          }
          this.processRegionIds((await loadJson(idListFile)).values, disambig);
        };
        this._loadRegionIDsPromises = [fetchAndProcess(this.regionIdsFile, false), fetchAndProcess(this.regionDisambigIdsFile, true)];
      }
      await Promise.all(this._loadRegionIDsPromises);
    } catch (_e) {
      console.log("Failed to load region IDS for ".concat(this.regionType));
    } finally {
      runInAction(() => this._loaded = true);
    }
  }

  /**
   * Returns the region variable of the given name, matching against the aliases provided.
   *
   * @param {string[]} varNames Array of variable names.
   * @returns {string} The name of the first column that matches any of the given aliases.
   */
  findRegionVariable(varNames) {
    return findVariableForAliases(varNames, [this.regionType, ...this.aliases]);
  }

  /**
   * If a disambiguation column is known for this provider, return a column matching its description.
   *
   * @param {string[]} varNames Array of variable names.
   * @returns {string} The name of the first column that matches any of the given disambiguation aliases.
   */
  findDisambigVariable(varNames) {
    if (!isDefined(this.disambigAliases) || this.disambigAliases.length === 0) {
      return undefined;
    }
    return findVariableForAliases(varNames, this.disambigAliases);
  }

  /**
   * Given a list of region IDs in feature ID order, apply server replacements if needed, and build the this._regions array.
   * If no propertyName is supplied, also builds this._idIndex (a lookup by attribute for performance).
   * @param {Array} values An array of string or numeric region IDs, eg. [10050, 10110, 10150, ...] or ['2060', '2061', '2062', ...]
   * @param {boolean} disambig True if processing region IDs for disambiguation
   */
  processRegionIds(values, disambig) {
    // There is also generally a `layer` and `property` property in this file, which we ignore for now.
    values.forEach((value, index) => {
      if (!isDefined(this._regions[index])) {
        this._regions[index] = {};
      }
      let valueAfterReplacement = value;
      if (typeof valueAfterReplacement === "string") {
        // we apply server-side replacements while loading. If it ever turns out we need
        // to store the un-regexed version, we should add a line here.
        valueAfterReplacement = this.applyReplacements(valueAfterReplacement.toLowerCase(), disambig ? "disambigServerReplacements" : "serverReplacements");
      }

      // If disambig IDS - only set this._regions properties - not this._index properties
      if (disambig) {
        this._regions[index].disambigProp = value;
        this._regions[index].disambigPropWithServerReplacement = valueAfterReplacement;
      } else {
        this._regions[index].regionProp = value;
        this._regions[index].regionPropWithServerReplacement = valueAfterReplacement;

        // store a lookup by attribute, for performance.
        // This is only used for region prop (not disambig prop)
        if (isDefined(value) && isDefined(valueAfterReplacement)) {
          // If value is different after replacement, then also add original value for _index
          if (value !== valueAfterReplacement) {
            this._idIndex[value] = index;
          }
          if (!isDefined(this._idIndex[valueAfterReplacement])) {
            this._idIndex[valueAfterReplacement] = index;
          } else {
            // if we have already seen this value before, store an array of values, not one value.
            if (Array.isArray(this._idIndex[valueAfterReplacement])) {
              this._idIndex[valueAfterReplacement].push(index);
            } else {
              this._idIndex[valueAfterReplacement] = [this._idIndex[valueAfterReplacement], index];
            }
          }

          // Here we make a big assumption that every region has a unique identifier (probably called FID), that it counts from zero,
          // and that regions are provided in sorted order from FID 0. We do this to avoid having to explicitly request
          // the FID column, which would double the amount of traffic per region dataset.
          // It is needed to simplify reverse lookups from complex matches (regexes and disambigs)
          this._regions[index].fid = index;
        }
      }
    });
  }

  /**
   * Apply an array of regular expression replacements to a string. Also caches the applied replacements in regionProvider._appliedReplacements.
   * @param {String} s The string.
   * @param {String} replacementsProp Name of a property containing [ [ regex, replacement], ... ], where replacement is a string which can contain '$1' etc.
   */

  applyReplacements(s, replacementsProp) {
    let r;
    if (typeof s === "number") {
      r = String(s);
    } else {
      r = s.toLowerCase().trim();
    }
    const replacements = this[replacementsProp];
    if (replacements === undefined || replacements.length === 0) {
      return r;
    }
    if (this._appliedReplacements[replacementsProp][r] !== undefined) {
      return this._appliedReplacements[replacementsProp][r];
    }
    replacements.forEach(function (rep) {
      r = r.replace(rep[2], rep[1]);
    });
    this._appliedReplacements[replacementsProp][s] = r;
    return r;
  }

  /**
   * Given a region code, try to find a region that matches it, using replacements, disambiguation, indexes and other wizardry.
   * @param {string | number} code Code to search for. Falsy codes return -1.
   * @param {string | number | undefined} disambigCode Code to use if disambiguation is necessary
   * @returns {Number} Zero-based index in list of regions if successful, or -1.
   */
  findRegionIndex(code, disambigCode) {
    if (!isDefined(code) || code === "") {
      // Note a code of 0 is ok
      return -1;
    }
    const codeAfterReplacement = this.applyReplacements(code, "dataReplacements");
    const id = this._idIndex[code];
    const idAfterReplacement = this._idIndex[codeAfterReplacement];
    if (!isDefined(id) && !isDefined(idAfterReplacement)) {
      return -1;
    }
    if (typeof id === "number") {
      // found an unambiguous match (without replacement)
      return id;
    } else if (typeof idAfterReplacement === "number") {
      // found an unambiguous match (with replacement)
      return idAfterReplacement;
    } else {
      const ids = id !== null && id !== void 0 ? id : idAfterReplacement; // found an ambiguous match
      if (!isDefined(disambigCode)) {
        // we have an ambiguous value, but nothing with which to disambiguate. We pick the first, warn.
        console.warn("Ambiguous value found in region mapping: " + (codeAfterReplacement || code));
        return ids[0];
      }
      if (this.disambigProp) {
        const processedDisambigCode = this.applyReplacements(disambigCode, "disambigDataReplacements");

        // Check out each of the matching IDs to see if the disambiguation field matches the one we have.
        for (let i = 0; i < ids.length; i++) {
          if (this._regions[ids[i]].disambigProp === processedDisambigCode || this._regions[ids[i]].disambigPropWithServerReplacement === processedDisambigCode) {
            return ids[i];
          }
        }
      }
    }
    return -1;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "_loaded", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "loadRegionIDs", [action], Object.getOwnPropertyDescriptor(_class.prototype, "loadRegionIDs"), _class.prototype), _class);
export { RegionProvider as default };
function findVariableForAliases(varNames, aliases) {
  // Try first with no transformation (but case-insensitive)
  for (let j = 0; j < aliases.length; j++) {
    const re = new RegExp("^" + aliases[j] + "$", "i");
    for (let i = 0; i < varNames.length; i++) {
      if (re.test(varNames[i])) {
        return varNames[i];
      }
    }
  }

  // Now try without whitespace, hyphens and underscores
  for (let j = 0; j < aliases.length; j++) {
    const aliasNoWhiteSpace = aliases[j].replace(/[-_\s]/g, "");
    const re = new RegExp("^" + aliasNoWhiteSpace + "$", "i");
    for (let i = 0; i < varNames.length; i++) {
      const varNameNoWhiteSpace = varNames[i].replace(/[-_\s]/g, "");
      if (re.test(varNameNoWhiteSpace)) {
        return varNames[i];
      }
    }
  }
  return undefined;
}